import React from 'react';

export const DualUse = () => {
  return (
    <section className="wingcore-dual-section">
      <div className="wingcore-dual-content">
        <h2 className="wingcore-dual-title">DUAL USE BY DESIGN</h2>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="836"
          height="1"
          viewBox="0 0 836 1"
          fill="none"
        >
          <path d="M0 0.5H836" stroke="url(#paint0_linear_7282_8602)" />
          <defs>
            <linearGradient
              id="paint0_linear_7282_8602"
              x1="0"
              y1="1"
              x2="836"
              y2="1"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.509" stopColor="#FF2238" />
              <stop offset="1" stopColor="#FF2238" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
        <p className="wingcore-dual-description">
          Featuring a MCU with the power to handle all common flight controller
          firmware including iNav, ArduPilot, and PX4, and enough servo outputs
          to manage even the most complex fixed wing platforms, the H7 WingCore
          is equally capable in both defense and enterprise roles.
        </p>
      </div>
    </section>
  );
};
